import Axios from 'axios'

export default {
  state: {
    gyms: [],
    gym: null
  },
  getters: {
    gyms(state) {
      return state.gyms
    },
    getGymById: (state) => {
      return state.gym
    }
  },
  mutations: {
    setGyms(state, payload) {
      state.gyms = payload
    },
    setGym(state, payload) {
      state.gym = payload
    },
    clearGym(state) {
      state.gym = null
    }
  },
  actions: {
    getGyms: async ({ commit }) => {
      commit('setLoading')
      let data = await Axios.get(process.env.VUE_APP_API_URL_GYMS)
        .then(res => {
          if (res.request.status != 200)
            res.data = []
          return res.data
        }
        ).catch(error => {
          commit('clearError')
          commit('setError', error)
          commit('setLoading')
        })
      commit('setGyms', data)
      commit('setLoading')
    },
    async loadGymById({ commit }, payload) {
      commit('clearGym')
      commit('setLoading')
      await Axios.get(process.env.VUE_APP_API_URL_GYM_BY_ID + payload)
        .then(res => {
          commit('setGym', res.data.data)
          commit('setLoading')
        }
        ).catch(error => {
          commit('setLoading')
          commit('clearError')
          commit('setError', error)
        })
    },
    async saveEvents({ commit, getters }, payload) {
      commit('setLoading')
      payload.forEach(element => {
        if (element.start.length > 5 && element.end.length) {
          element.start = element.start.trim().substring(11)
          element.end = element.end.trim().substring(11)
        }
      })
      await Axios.put(process.env.VUE_APP_API_URL_GYM_EVENTS + getters.user.gym._id,
        { events: payload })
        .then(res => {
          commit('addEvents', JSON.parse(JSON.stringify(res.data.data.events)))
          commit('setLoading')
        }
        ).catch(error => {
          commit('setLoading')
          commit('clearError')
          commit('setError', error)
        })
    }
  }
}
